import { mobileNav } from "./mobileNav.js";
import { header } from "./header.js";
import { hero } from "./hero.js";
import { accordion } from "./accordion.js";
import { granteesCarousel } from "./granteesCarousel.js";
import { animateOnScroll } from "./animateOnScroll.js";

(function () {
  header();
  mobileNav();
  hero();
  accordion();
  granteesCarousel();
  animateOnScroll();
})();
